export var isSSOEnabled = process.env.IS_SSO_ENABLED === 'true';
